module.exports = __webpack_public_path__ + "static/img/courier-map-marker-busy.26ddce31.svg";